import React from 'react';
import { BagCheck } from 'react-bootstrap-icons';

interface Props {
  title: string;
  subTitle?: string | React.ReactNode;
}

const PageHeader = ({ title, subTitle }: Props) => {
  return (
    <div className="d-flex align-items-center">
      <div className="border rounded-3 me-4 p-10">
        <BagCheck height={32} width={32} className="payment-service-color" />
      </div>
      <div className="d-flex flex-column">
        <h4 className="fs-4 fw-bold m-0 ">{title}</h4>
        <span className="fs-6">{subTitle}</span>
      </div>
    </div>
  );
};

export default PageHeader;